import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { User } from '../model/user.model';
import { Observable, Subject } from 'rxjs';
import { AppSettings } from '../../app.constant';
import { Options } from 'selenium-webdriver/chrome';
import { tap } from 'rxjs/operators';
import { Role } from '../interface/role';

@Injectable({
  providedIn: 'root'
})

export class UserService {
  httpOptions: any;
  headers: any;

  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }
  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      })
    };
  }

  getAllUsers(url) {
    return this.http.get<User>(url, this.httpOptions)
  }

  getUserData(url, param) {
    return this.http.post<User>(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  GetUserByID(url, param) {
    return this.http.post<User>(url, param, this.httpOptions)
  }

  postUser(url, param) {
    return this.http.post<User>(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  updateUser(url, param) {
    return this.http.put<User>(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  //  getUser(): Observable<User[]>{
  //    return this.http.get<User[]>(url,this.httpOptions)
  //  }

  getAllRole(url) {
    return this.http.get<User>(url, this.httpOptions)
  }

  postRole(url, param) {
    return this.http.post<Role>(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }
  deleteUserByID(url, param) {
    return this.http.put<User>(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

}
